import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ProfileIntroEditDialogModule } from '@main-client/src/app/profile/profile-intro-edit-dialog/profile-intro-edit-dialog.module';

import { ProfileAboutComponent } from './profile-about.component';

@NgModule({
  declarations: [ProfileAboutComponent],
  exports: [ProfileAboutComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    ProfileIntroEditDialogModule,
  ],
})
export class ProfileAboutModule {}
